import 'whatwg-fetch';
import callAPIHandler from './apiHandler';
import getAPIClient from './apiClient';
import { getLinkToken, isNoTrackView } from '../commonUtil/util';

function callAPI(funName, args, apiName = 'engagement', version = 'v1') {
    return callAPIHandler(getAPIClient(), apiName, version, funName, args);
}

export async function getLinkInfo(linkToken = '') {
    const result = await callAPI('getLinkInfo', { linkToken });
    return result;
}

export async function getManifest(linkToken = '', contentManifestRequest = {}, trackingType) {
    const isSellerPreview = isNoTrackView();
    const result = await callAPI('getManifest', { linkToken, contentManifestRequest, 'X-Seismic-TrackingType': trackingType, isSellerPreview });
    return result;
}

export async function startSession(linkToken = '', sessionRequestInfo = {}) {
    const result = await callAPI('startSession', { linkToken, sessionRequestInfo });
    return result;
}

export async function endSession(tenant = '', sessionId = '') {
    const result = await callAPI('endSession', { tenant, sessionId });
    return result;
}

export async function trackViewerEvent(linkToken = '', viewerEventRequestModel = {}) {
    const result = await callAPI('trackViewerEvent', { linkToken, viewerEventRequestModel });
    return result;
}

export async function getSenderInfo(liveSendToken = '') {
    const result = await callAPI('getSenderInfo', { liveSendToken });
    return result;
}

export async function getLocaionInfo() {
    const result = await callAPI('detectViewerLocation');
    return result;
}

export async function optOutSession(tenant, sessionId) {
    const result = await callAPI('optOutSession', { tenant, sessionId });
    return result;
}

export async function optInSession(tenant, sessionId) {
    const result = await callAPI('optInSession', { tenant, sessionId });
    return result;
}

export async function reportClientLog(logInfo, isNeedReport = false) {
    if (!isNeedReport) return false;

    const result = await callAPI('reportClientLog', { linkToken: getLinkToken(), logInfo });
    return result;
}

export async function getContentAssetsDownload({ linkToken, body, trackingType }) {
    const isSellerPreview = isNoTrackView();
    const result = await callAPI('GetContentDownload', { linkToken, body, 'X-Seismic-TrackingType': trackingType, isSellerPreview });
    return result;
}

export async function postPasswordValidate({ linkToken, password, compliancePassword }) {
    const request = {
        linkToken,
        body: {
            Password: password,
            CompliancePassword: compliancePassword
        }
    };
    const result = await callAPI('PostPasswordValidate', request);
    return result;
}
